import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "~/queryKeys";
import { salesforceServiceSingleton } from "~/services/salesForce/salesForce";
import { useLocaleStore } from "~/stores/locale/useLocaleStore";
import { useFetchAccessToken } from "./useFetchAccessToken";

export const useFetchPaymentOptions = () => {
  const { locale } = useLocaleStore();
  const { data } = useFetchAccessToken();
  const { opportunityId } = useParams();

  return useQuery({
    queryKey: [QueryKeys.useFetchPaymentOptions, locale],
    queryFn: () =>
      salesforceServiceSingleton.getPaymentOptions(
        data?.accessToken ?? "",
        opportunityId ?? "",
        locale
      ),
    enabled: !!data?.ensureAccessTokenIsValid?.(),
  });
};
